import { Pipe, PipeTransform } from '@angular/core';
import { JobDetailQuestions, JobFieldsToDisplayInJobDetails } from 'app/Modules/Job/Models/job-side-preview.model';
import * as _ from 'lodash';
@Pipe({
  name: 'showjobdetailsfieldsbyQId',
  standalone: true
})
export class ShowjobdetailsfieldsbyQIdPipe implements PipeTransform {


  transform(aoFields: JobDetailQuestions[] | null, jobFieldsToDisplay: JobFieldsToDisplayInJobDetails | null, dynamicStrings?: any): JobDetailQuestions[] {
    if (!aoFields) {
      return [];
    }
    const renderedFields: any[] = [];


    if (jobFieldsToDisplay?.Position1 != null) {
      var jobPos1Field = _.find(aoFields, { 'QuestionId': jobFieldsToDisplay.Position1.toLowerCase() });
      if (jobPos1Field != undefined) {
        jobPos1Field.ClassName = "position1InJobDetails";
        jobPos1Field.QuestionName = "";
        renderedFields.push(jobPos1Field);
      }
    }
    if (jobFieldsToDisplay?.JobTitle != null) {
      var jobTitleField = _.find(aoFields, { 'QuestionId': jobFieldsToDisplay.JobTitle.toLowerCase() });
      if (jobTitleField != undefined) {
        jobTitleField.ClassName = "jobtitleInJobDetails";
        jobTitleField.QuestionName = "";
        renderedFields.push(jobTitleField);
      }
    }

    if (jobFieldsToDisplay?.Position3 != null && jobFieldsToDisplay?.Position3.length > 0) {
      _.each(jobFieldsToDisplay.Position3, (position3: any) => {
        var jobPos3Field = _.find(aoFields, { 'QuestionId': position3 });
        if (jobPos3Field != undefined) {
          jobPos3Field.ClassName = "position3InJobDetails";
          jobPos3Field.QuestionName = "";
          renderedFields.push(jobPos3Field);
        }
      });
    }

    if (jobFieldsToDisplay?.Summary != null && jobFieldsToDisplay?.Summary.length > 0) {
      var jobSummaryField = _.find(aoFields, { 'QuestionId': jobFieldsToDisplay.Summary.toLowerCase() });
      if (jobSummaryField != undefined) {
        jobSummaryField.ClassName = "jobdescriptionInJobDetails";
        renderedFields.push(jobSummaryField);
      }
    }
    var position = 0;
    if (jobFieldsToDisplay?.Section2Fields != null && jobFieldsToDisplay?.Section2Fields.length > 0) {
      _.each(jobFieldsToDisplay.Section2Fields, (section2Field: any) => {
        var jobSection2Field = _.find(aoFields, { 'QuestionId': section2Field });
        if(jobSection2Field != undefined ) {
          if (jobSection2Field?.QuestionType == 'textarea') {
            jobSection2Field.ClassName = "section2LeftfieldsInJobDetails jobDetailTextArea ";
            
            renderedFields.push(jobSection2Field);
            position = -1;
          }
          else {
            if (jobSection2Field != null) {
              if (jobSection2Field?.QuestionType?.toLowerCase() == "dateclosed") {
                    jobSection2Field.QuestionName = "Job Expires";
                }
              if (position % 2 == 0) {
                jobSection2Field.ClassName = "section2LeftfieldsInJobDetails";
              }
              else {
                jobSection2Field.ClassName = "section2RightfieldsInJobDetails";
              }
              renderedFields.push(jobSection2Field);
            }

          }
        position = ++position;
      }
      });
    }
    return renderedFields;
  }

}
